'use client'

import React, { useState } from "react";
import Modal from "../modal/Modal";
import { useDispatch, useSelector } from "react-redux";
import { ClockIcon } from "@heroicons/react/24/solid";
import {
  addToCart,
  decreaseCart,
  incrementCart,
} from "../../store/reducers/cartSlice";
import { original } from "@reduxjs/toolkit";
function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

const ProductCard = ({data}) => {
    let [isOpen, setIsOpen] = useState(false);
      const dispatch = useDispatch();
      const cart = useSelector((state) => state.cart);
    
      function closeModal() {
        setIsOpen(false);
      }
    
      function openModal() {
        setIsOpen(true);
      }
    
      const handleAddToCart = (product) => {
        dispatch(addToCart(product));
      };
    
      const MAX_LENGTH = 20;
    
      const language = useSelector((state) => state.language.language);
      const text = {
          minuteText: language === "en" ? "minutes": "मिनट",
          };
    
    
      const Cart = cart.cartItems.find((cartItem) => cartItem.id === data.id);
  return (
    <>
<div className="product-card w-[300px] rounded-md shadow-xl overflow-hidden relative cursor-pointer snap-start shrink-0 py-8 px-6 bg-white flex flex-col items-center justify-center gap-3 transition-all duration-300 group z-10">
 {/* Discount Tag */}
 
{/* <div className="absolute -left-[40%] top-0 group-hover:rotate-12 transition-all duration-300 group-hover:scale-150">
        <div className="flex gap-1">
          <svg strokeLinejoin="round" strokeLinecap="round" strokeWidth={1} fill="none" viewBox="0 0 24 24" className="fill-gray-300 rotate-[24deg]" height={200} width={200} xmlns="http://www.w3.org/2000/svg">
            <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
          </svg>
        </div>
      </div> */}
      <div
          className="absolute rounded-full bg-white  z-20 left-1/2 top-[44%] h-[110%] w-[110%] -translate-x-1/2 group-hover:top-[58%] transition-all duration-300"
        />      <div className="para uppercase text-center leading-none z-40">
        {/* <p className="text-black font-semibold text-xs font-serif">Best</p> */}
        <p className="text-black font-semibold text-xs font-serif">{language === "en" ? data.product_name : data.product_name_hindi}</p>
      </div>
      <div className="img w-[180px] aspect-square bg-gray-100 z-40 rounded-md">
      {data.discount === 0 ? (
            ""
          ) : (
            <span className="absolute text-dark text-xs bg-orange-500 text-black py-1 px-2 rounded font-medium z-5 right-1 top-1">
              {Math.ceil(data.discount)}% Off
            </span>
          )}
          {data.quantity !== 0 ? (
            ""
          ) : (
            <span className="absolute inline-flex items-center justify-center px-2 py-1 bg-red-100 text-red-600 border-0 rounded-full text-xs font-semibold z-10 left-4 top-4">
              Stock Out
            </span>
          )}
      <img
      onClick={openModal}
              src={data.photo_url}
              alt={data.name}
              decoding="async"
              data-nimg="intrinsic"
              className="object-cover transition duration-150 ease-linear transform group-hover:scale-105"
              style={{
                inset: "0px",
                boxSizing: " border-box",
                padding: "0px",
                border: "none",
                margin: "auto",
                display: " block",
                width: "160px",
                height: "160px",
                minWidth: "100%",
                maxWidth: "100%",
                minHeight: "100%",
                maxHeight: " 100%",
              }}
            />
      </div>
      <div className="btm-_container z-40 flex flex-row justify-between items-end gap-10">
        <div className="flex flex-col items-start gap-1">
          <div className="inline-flex gap-3 items-center justify-center">
            <div className="p-1 bg-white flex items-center justify-center rounded-full">
              <svg strokeLinejoin="round" strokeLinecap="round" strokeWidth={1} fill="none" viewBox="0 0 24 24" className="fill-gray-800 h-3 w-3 stroke-none" xmlns="http://www.w3.org/2000/svg">
                <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z" />
              </svg>
            </div>
            <p className="font-semibold text-xs text-black">
              
            <span className="font-normal text-base text-black">
              <b>
                ₹{data.currentprice} {" "}
              </b>
            </span>
              {data.currentprice ===data.originalPrice ? (
                ""
              ) : (
                <del
                    className="font-normal text-base text-black ml-1"
                    style={{
                      textDecorationColor: '#ec4899', // Tailwind's pink-600 color in HEX
                      textDecorationThickness: '2px', // Optional: Thicker strikethrough line
                    }}
                  >
                    ₹{data.originalPrice}
                  </del>
              )}
            </p>
          </div>
          <div className="flex flex-row gap-2">
            <div className="inline-flex gap-3 items-center justify-center">
              <div className="p-1 bg-white flex items-center justify-center rounded-full">
              <ClockIcon className="h-5 w-5" aria-hidden="true" />
              </div>
              <p className="font-semibold text-xs text-black"><span className="font-normal text-base text-black">{data.time_duration}{" "} {text.minuteText}</span></p>
            </div>
          </div>
          
                        
          
        </div>
        <div className="btn">
          {Cart ? (
                        <div>
                          <div className="h-9 w-auto flex flex-wrap items-center justify-evenly py-1 px-2 bg-pink-600 text-black rounded">
                            <button onClick={() => dispatch(decreaseCart(data))}>
                              <span className="text-dark text-base">
                                <svg
                                  stroke="currentColor"
                                  fill="currentColor"
                                  strokeWidth="0"
                                  viewBox="0 0 512 512"
                                  height="1em"
                                  width="1em"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    fill="none"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    strokeWidth="32"
                                    d="M400 256H112"
                                  ></path>
                                </svg>
                              </span>
                            </button>
                            <p className="text-sm text-dark px-1 font-semibold">
                              {Cart.cartQuantity}
                            </p>
                            <button onClick={() => dispatch(incrementCart(data))}>
                              <span className="text-dark text-base">
                                <svg
                                  stroke="currentColor"
                                  fill="currentColor"
                                  strokeWidth="0"
                                  viewBox="0 0 512 512"
                                  height="1em"
                                  width="1em"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    fill="none"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    strokeWidth="32"
                                    d="M256 112v288m144-144H112"
                                  ></path>
                                </svg>
                              </span>
                            </button>
                          </div>
                        </div>
                      ) : (
                        <button
                          disabled={data.quantity === 0 ? true : false}
                          onClick={() => handleAddToCart(data)}
                          ariallabel="chart"
                          className={data.quantity === 0 ? "!cursor-default h-9 w-9 flex items-center justify-center border border-gray-200 rounded text-pink-600 hover:border-emerald-500 hover:bg-pink-600 hover:text-black transition-all":"!cursor-pointer h-9 w-9 flex items-center justify-center border border-gray-200 rounded text-pink-600 hover:border-emerald-500 hover:bg-pink-600 hover:text-white transition-all"}
                        >
                          <span className="text-xl">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              className="h-6 w-6"
                              fill="white"
                              // fill='bg-pink-600'
                              viewBox="0 0 24 24"
                              stroke="currentColor"
                              strokeWidth="2"
                            >
                              <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                d="M16 11V7a4 4 0 00-8 0v4M5 9h14l1 12H4L5 9z"
                              />
                            </svg>
                          </span>
                        </button>
                      )}
        </div>
      </div>
    </div>
          <Modal data={data} isOpen={isOpen} closeModal={closeModal} />
    
    </>
  );
}

export default ProductCard;
